module.exports = __webpack_public_path__ + "static/media/Medial.7defd6c4.png";